<template>
  <el-dialog title="快捷编辑" :visible.sync="dialogVisible" :close-on-click-modal="false" append-to-body width="70%">
    <template v-if="type==='input'">
      <div class="label mb10" style="font-size:14px;">{{label}}:</div>
      <el-input
        v-model="value"
        type="textarea"
        :rows="2"
        placeholder="请输入内容">
      </el-input>
    </template>
    <template v-else-if="type==='question'">
      <div class="label mb10" style="font-size:14px;">{{label}}:</div>
        <el-button type="text" @click="openFindQuestion">
        <span>从问题库中搜索导入</span>
      </el-button>
      <div v-for="(item, index) in questionValue" :key="`projectCoachQuestion${index}`" class="edit-dialog-item qa-item" :class="{'dash-top': index!=0}">
        <div class="qa-wrap">
          <div class="qa-input">
            <span class="qa-title">Q:</span>
            <el-input type="textarea" v-model="questionValue[index]['Q']" placeholder="请输入该职位可能会存在的问题。例：听说这家公司固薪很低"></el-input>
          </div>
          <div class="qa-input">
            <span class="qa-title">A:</span>
            <el-input type="textarea" v-model="questionValue[index]['A']" placeholder="请输入对该问题的应答。例：是的但同职位的上升空间和可接触资源是远高于其他公司的"></el-input>
          </div>
        </div>
        <div class="qa-btn">
          <el-button type="text" :class="{invisible: index==0}" @click="removeQuestion(index)">
            <i class="el-icon-delete"></i>
          </el-button>
        </div>
      </div>
      <el-button type="primary" size="small" @click="addQuestion">
        <span>+添加</span>
      </el-button>
      <FindQuestion ref="FindQuestion" :has-questiones="questionValue" @addQuestion="componentAddQuestion" @removeQuestion="componentRemoveQuestion"></FindQuestion>
    </template>
    <tagInputInEdit
      v-else
      v-model="tagInputValue"
      :label="label"
      :translate="label==='业务特点'?translate:{}"
      :no-tag="noTag"
    >
      <div class="label mb10" style="font-size:14px;">{{label}}:</div>
    </tagInputInEdit>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="cancel">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import tagInputInEdit from '../../../../../company/src/baseComponent/tagInputInEdit.vue'
import * as commonvariant from '../../../../../company/statistics/variant/commonvariant'
import FindQuestion from '../../../../../project/src/components/CreateProject20/FindQuestion'

export default {
  components:{ tagInputInEdit, FindQuestion },
  data() {
    return {
      dialogVisible: false,
      type:'input',
      value:'',
      tagInputValue:{},
      questionValue:[],
      label:'',
      translate: commonvariant.风格对应,
    }
  },
  methods: {
    async open({value,label,type='input',noTag=false,confirmFunc=()=>{}}) {
      this.dialogVisible = true
      this.label = label
      this.type = type
      if(type==='input'){
        this.value = value
      }else if(type==='question'){
        this.questionValue = window._.cloneDeep(value || [])
        if(this.questionValue.length===0) this.addQuestion()
      }else{
        this.tagInputValue = window._.cloneDeep(value)
      }
      this.noTag = false
      this.confirmFunc = confirmFunc
    },
    cancel(){
      this.dialogVisible = false
    },
    confirm(){
      this.dialogVisible = false
      if(this.type==='input'){
        this.confirmFunc(this.value)
      }else if(this.type==='question'){
        this.confirmFunc(this.questionValue.filter(v=>v.Q||v.A))
      }else{
        this.confirmFunc(this.tagInputValue)
      }
    },
    openFindQuestion() {
      this.$refs.FindQuestion.open()
    },
    addQuestion() {
      this.questionValue.push({ Q: '', A: '' })
    },
    removeQuestion(index) {
      this.questionValue.splice(index, 1)
    },
    componentAddQuestion(question) {
      for (let i = 0, leng = this.questionValue.length; i < leng; i++) {
        const item = this.questionValue[i]
        if (!item.Q && !item.A) {
          this.questionValue.splice(i, 1, question)
          this.$message.success('添加成功')
          return
        }
      }
      this.questionValue.push(question)
      this.$message.success('添加成功')
    },
    componentRemoveQuestion(question) {
      this.questionValue = this.questionValue.filter(
        (v) => v.Q !== question.Q || v.A !== question.A,
      )
      this.$message.success('已移除')
    },
  }
}
</script>
<style scoped>
.edit-dialog-item {
  padding: 0 10px;
  margin-bottom: 10px;
}
.invisible {
  visibility: hidden;
}
.qa-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
}
.dash-top {
  border-top: 1px dashed #c9c9ce;
}
.qa-wrap {
  flex-grow: 1;
  margin-right: 30px;
}
.qa-input {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.qa-input:last-of-type {
  margin-bottom: 0;
}
.qa-title {
  flex-shrink: 0;
  width: 30px;
}
.qa-btn i {
  font-size: 24px;
}
</style>
